import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import styles from '../../cards.module.scss';
import { cleanHtml } from '../../../../utils/stringHelper';

function PopupItem({ popup, handleClickPopup }) {
  console.log(popup);
  return (
    <div className={styles.projectCard} onClick={handleClickPopup}>
      <img
        className={styles.projectImage}
        src={popup?.image ? popup?.image?.file : getImage('img-ph.png')}
        alt={popup?.image ? popup?.image?.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{popup.title}</p>
          <p className={styles.subtitle}>{popup.button_label}</p>
          <p className={styles.subtitle}>{popup.button_link}</p>
          <p className={styles.subtitle}>{popup.content}</p>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('maisonmousse.popUpActive', popup.is_active).label,
              bgColor: getConstant('maisonmousse.popUpActive', popup.is_active).bgColor
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default PopupItem;
